import { List } from 'immutable';
import { IDispatchId, IRequestError } from '../../utils/helpers/redux.helper';
import { ProvisioningFeatures } from './provisioning-features.model';
import { AccountQuota } from './sub-models/account-quota.model';
import { Banner } from './sub-models/banner.model';
import { Canvas } from './sub-models/canvas.model';

// action enums
export enum ActionsEnum {
  FETCH_QUOTAS_BANNERS_CANVASES = 'FETCH_QUOTAS_BANNERS_CANVASES',
  UPDATE_QUOTAS_BANNERS_CANVASES = 'UPDATE_QUOTAS_BANNERS_CANVASES',
  FETCH_FEATURES_DATA = 'FETCH_FEATURES_DATA',
  FETCH_FEATURES_DATA_SUCCESS = 'FETCH_FEATURES_DATA_SUCCESS',
  FETCH_FEATURES_DATA_ERROR = 'FETCH_FEATURES_DATA_ERROR',
  UPDATE_FEATURES_DATA = 'UPDATE_FEATURES_DATA',
}

// action payloads
export interface IUpdateQuotasBannersCanvases {
  quotas: List<AccountQuota>;
  banners: List<Banner>;
  canvases: List<Canvas>;
}

export interface IFeaturesDataPayload {
  featuresData: ProvisioningFeatures;
}

export interface IFetchFeaturesDataPayload
  extends IFeaturesDataPayload,
    IDispatchId {}

// action definitions
export interface FetchQuotasBannersCanvases {
  type: ActionsEnum.FETCH_QUOTAS_BANNERS_CANVASES;
}

export interface UpdateQuotasBannersCanvases {
  type: ActionsEnum.UPDATE_QUOTAS_BANNERS_CANVASES;
  payload: IUpdateQuotasBannersCanvases;
}

export interface FetchFeaturesData {
  type: ActionsEnum.FETCH_FEATURES_DATA;
  payload: IDispatchId;
}

export interface FetchFeaturesDataSuccess {
  type: ActionsEnum.FETCH_FEATURES_DATA_SUCCESS;
  payload: IFetchFeaturesDataPayload;
}

export interface FetchFeaturesDataError {
  type: ActionsEnum.FETCH_FEATURES_DATA_ERROR;
  payload: IRequestError;
}

export interface UpdateFeaturesData {
  type: ActionsEnum.UPDATE_FEATURES_DATA;
  payload: IFeaturesDataPayload;
}

// action creators
export const fetchQuotasBannersCanvases = (): FetchQuotasBannersCanvases => ({
  type: ActionsEnum.FETCH_QUOTAS_BANNERS_CANVASES,
});

export const updateQuotasBannersCanvases = (
  quotas: List<AccountQuota>,
  banners: List<Banner>,
  canvases: List<Canvas>
): UpdateQuotasBannersCanvases => ({
  type: ActionsEnum.UPDATE_QUOTAS_BANNERS_CANVASES,
  payload: {
    quotas,
    banners,
    canvases,
  },
});

export const fetchFeaturesData = (dispatchId: string): FetchFeaturesData => ({
  type: ActionsEnum.FETCH_FEATURES_DATA,
  payload: {
    dispatchId,
  },
});

export const fetchFeaturesDataSuccess = (
  dispatchId: string,
  featuresData: ProvisioningFeatures
): FetchFeaturesDataSuccess => ({
  type: ActionsEnum.FETCH_FEATURES_DATA_SUCCESS,
  payload: {
    dispatchId,
    featuresData,
  },
});

export const fetchFeaturesDataError = (
  dispatchId: string,
  error: Error
): FetchFeaturesDataError => ({
  type: ActionsEnum.FETCH_FEATURES_DATA_ERROR,
  payload: {
    dispatchId,
    error,
  },
});

export const updateFeaturesData = (
  featuresData: ProvisioningFeatures
): UpdateFeaturesData => ({
  type: ActionsEnum.UPDATE_FEATURES_DATA,
  payload: {
    featuresData,
  },
});
